import { getCurrentContractAddresses } from "src/configs/address";
import ABI from "src/contract-logic/abis/PancakeRouterABI.json";
import { web3Reader } from "src/wallet-connection";

const { PANCAKE_ROUTER } = getCurrentContractAddresses();
var contractReader = null;

function getContractReader() {
  if (!contractReader) {
    contractReader = new web3Reader.eth.Contract(ABI, PANCAKE_ROUTER);
  }
  return contractReader;
}

async function getAmountsOut(amountIn, path) {
  const res = await getContractReader().methods.getAmountsOut(amountIn, path).call();
  return res;
}

async function getAmountsIn(amountOut, path) {
  try {
    const res = await getContractReader().methods.getAmountsIn(amountOut, path).call();
    return res;
  } catch (e) {
    console.error(e);
  }
}

export default {
  ABI,
  ADDRESS: PANCAKE_ROUTER,
  getAmountsOut,
  getAmountsIn,
};
